import React, { useEffect, useState } from 'react';
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom"
import { BASE } from "../basedata/constants";
import FacialInstructions from "../components/Intructions/FacialInstructions";
import MobilePagination from '../components/MobilePagination/MobilePagination';
import { useTranslation } from 'react-i18next';
import "./FacialInstructionsPage.sass"
import { useStep } from '../context/StepContext'
import { UnicoCheckBuilder, SelfieCameraTypes, UnicoThemeBuilder, SDKEnvironmentTypes, DocumentCameraTypes, UnicoConfig, LocaleTypes } from 'unico-webframe'
import SelfieDone from '../components/SelfieDone/SelfieDone';
import SelfieSuccess from '../components/SelfieSuccess/SelfieSuccess';

const DEFAULT_UNICO_HOSTNAME = 'https://botafogo.bepass.com.br';
const DEFAULT_UNICO_HOST_KEY = 'r001-4a6a6604-e021-413c-a522-fcce27c4b8d1';

const FacialInstructionsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setStep } = useStep();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [faceStep, setFaceStep] = useState('instructions');
    const [selfieImage, setSelfieImage] = useState('');
    const [selfieImageEncripted, setSelfieImageEncripted] = useState('');

    useEffect(() => {
      setStep(3);
    }, []);


  const hadouken = (error:any) => {
        setLoading(true);

        console.error("unico-webframe error:", {
          code: error?.code,
          message: error?.message,
          fullError: error
        });

        setTimeout(() => {
          openCamera()
        }, 3000);
  }

    const callback = {
    on: {
      success: function(obj: any) {
        console.log("Success capturing image");

        console.log(obj.base64)
        console.log(obj.encrypted)
        setFaceStep('captured')
        setSelfieImage(obj.base64)
        setSelfieImageEncripted(obj.encrypted)
      },
      error: () => {hadouken(error)},
      user_canceled: function() {
        console.log("Capture canceled by user.");
      }
    }
  };

  const unicoTheme = new UnicoThemeBuilder()
    .setColorSilhouetteSuccess(BASE.company.secondaryColor)
    .setColorSilhouetteError("#D50000")
    .setColorSilhouetteNeutral("#fcfcfc")
    .setBackgroundColor("#f3f8fb")
    .setColorText(BASE.company.secondaryColor)
    .setBackgroundColorComponents(BASE.company.secondaryColor)
    .setColorTextComponents("#f3f8fb")
    .setBackgroundColorButtons(BASE.company.secondaryColor)
    .setColorTextButtons("#f3f8fb")
    .setBackgroundColorBoxMessage("#ffffff")
    .setColorTextBoxMessage("#333")
    .build();


  // Main camera instance with theme
  const unicoCamera = new UnicoCheckBuilder()
    // .setResourceDirectory("/resources") /*-- A partir da versão 3.18.0, o SDK busca os recursos adicionais automaticamente se o método setResourceDirectory não for usado e as configurações de CSP estiverem corretas. --/*
    // .setModelsPath("/models")
    .setEnvironment(SDKEnvironmentTypes.PROD)
    .setTheme(unicoTheme)
    .build();

  // Functions to open different camera modes
  const openSelfieCameraLiveness = async () => {
    const config = new UnicoConfig()
      .setHostname(DEFAULT_UNICO_HOSTNAME)
      .setHostKey(DEFAULT_UNICO_HOST_KEY);

    const cameraPromised = unicoCamera
      .prepareSelfieCamera(config, SelfieCameraTypes.LIVENESS)
      .catch(() => console.error('Error initializing liveness camera'));

    cameraPromised.then((cameraOpener: { open: (arg0: { on: { success: (obj: any) => (void); error: (error: any) => (void); user_canceled: () => void; }; }) => any; }) => cameraOpener.open(callback));
  };

  // Maps camera types to their respective functions
  const cameraHandlers: Record<string, () => Promise<void>> = {
    liveness: openSelfieCameraLiveness
  };


  // Generic function to open any type of camera with error handling
  const openCamera = async (cameraType: string = 'liveness') => {
    console.log(`Attempting to open camera: ${cameraType}`);
    setLoading(true);
    setError(null);

    try {
      const handler = cameraHandlers[cameraType];
      if (!handler) throw new Error(`Invalid camera type specified: ${cameraType}`);

      await handler();
    } catch (errorCatch) {
      console.error(`Error PREPARING ${cameraType} camera:`, errorCatch);
      const errorMessage = errorCatch instanceof Error ? errorCatch.message : String(errorCatch);
      setError(`Failed to initialize camera (${cameraType}). ${errorMessage}. Please check permissions and try again.`);
      setTimeout(() => setError(null), 7000);
    } finally {
      console.log(`FINALLY block executed after trying to prepare ${cameraType} camera.`);
      setTimeout(() => {
        setLoading(false);
      }, 10000);
    }
  };

      const handleUserResponse = (response:any) => {
        if (response.status === 'success') {
          console.log(response)
          setFaceStep('selfieDone')
            // setUserState('selfieDone')
        } else {
          setFaceStep('selfieDone')
        }
    }

    return (

      loading ? (
        <div className="loader">
          <div className="spinner">
          </div>
        </div>
      ):(
       <>
      {BASE.company.iframe_liveness === false ? (

      <FacialInstructions
        handleCloseInstructions={() => navigate('/selfie')}
        togglePanel={() => { }}
      />
      ):(
      faceStep === 'instructions' ? (
      <FacialInstructions
        handleCloseInstructions={openCamera}
        togglePanel={() => { console.log('foi u, dos, re') }}
      />
      ): faceStep === 'captured' ? (
        <SelfieDone selfieBase64={`data:image/jpeg;base64,${selfieImage}`} selfieEncripted={selfieImageEncripted} onResponse={handleUserResponse} selfieAttempts={0} />
      ):(
        <SelfieSuccess selfieBase64={`data:image/jpeg;base64,${selfieImage}`} />
      ))}
      </>
      )
      );
};

export default FacialInstructionsPage;
